export enum EnumTipoCalculoConcepto {
  PrecioUnitario = 1,
  PrecioFijo = 2,
  Porcentaje = 3,
  PrecioUnitarioCaudal = 4,
  PrecioUnitarioContrato = 5,
  PrecioUnitarioUso = 6,
  FlexibilidadBC = 7,
  PrecioUnitarioPeajeDuracion = 8,
  PrecioUnitarioPeaje = 9,
  //ATRTransporteFijo = 10,
  //ATRTransporteVariable = 11,
  FlexibilidadCB = 12,
  FlexibilidadTL = 13,
  //TasaMunicipal = 14,
  PorcentajeUso = 15,
  PrecioUnitarioDuracion = 16,
  FlexibilidadBN = 17,
  PorcentajeRegion = 18,
  CompraVenta = 19,
  Fee = 20,
  PrecioFijoComision = 21,
  PrecioUnitarioFactura = 22,
  PorcentajeFacturaFinal = 23,
  PrecioFijoBandaProducto = 24,
  PrecioFijoPedido = 25,
  PrecioUnitarioNaturalezaDuracion = 26,
  PrecioUnitarioTamanioBuque = 27,
  Agregador = 28,
  Dummy = 29,
  PrecioUnitarioDuracionPunto = 30,
  AgregadorGlobal = 31,
  PorcentajeIEE = 32,
  AgregadorGlobalPeriodo = 33,
  FlexibilidadTLSF = 34,
  FlexibilidadTLMixta = 35,
  FlexibilidadTLUmbral = 36,
  FlexibilidadTLBonificacion = 37,
  BonificacionDesvio = 38,
  TLRegularizacionCierre = 39,
  TLGdOs = 40,
  PorcentajeIVA = 41,
  PorcentajeIVARefactura = 42,
  PorcentajeIEERefactura = 43,
  GeneracionSaldo = 44,
  CompensacionSinBateria = 45,
  CompensacionConBateria = 46,
  FlexibilidadCompBonificacion = 47,
  FlexibilidadPPAFinanciero = 48,
  FlexibilidadCierre = 49,
  LucroCesante = 50,
  PenalizacionGDO = 51,
  PenalizacionSWAP = 52,
  CompromisoConsumo = 53,
  PrecioUnitarioParametroPeaje = 54,
  PrecioUnitarioIEH = 55,
  PrecioUnitarioIEHRefactura = 56,
  //Electricidad
  PrecioUnitarioPeajePeriodo = 1100,
  PrecioEnergiaReactiva = 1101,
  PrecioPassThrough = 1102,
  PrecioPassPool = 1103,
  PrecioUnitarioPeriodos = 1104,
  AccionBalance = 1105,
  ParametroPeriodo = 1106,
  PrecioUnitarioRegion = 1107,
  ImporteDirecto = 1120
}
